var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "np_approve_1672728_000000") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2021/FormIcon---Tick",
    transform: "translate(-13.000000, -13.000000)",
    fill: "#007B4B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_approve_1672728_000000",
    transform: "translate(13.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99446154,11.8578462 C8.856,11.8578462 8.72294677,11.8070058 8.62017231,11.7139763 L5.51032615,8.86139169 C5.28099785,8.65478215 5.26261015,8.30106554 5.46921969,8.07171785 C5.67582923,7.84238954 6.02954585,7.82400185 6.25889354,8.03061138 L8.95889354,10.5229191 L16.7592628,1.95768831 C16.9647923,1.72836277 17.3174289,1.70888954 17.5467766,1.91441908 C17.7771849,2.11994862 17.7955754,2.47258523 17.5900458,2.70301292 L9.41527662,11.6780898 C9.315756,11.7862615 9.17729446,11.8511668 9.03018738,11.8576578 L8.99446154,11.8578462 Z M16.0615385,6.00673846 C17.0188615,8.39412 16.7322185,11.1015692 15.29568,13.2358154 C13.8591415,15.3711415 11.4597415,16.6572 8.88740308,16.6702154 C6.31395692,16.6842778 3.90168,15.4240615 2.44257231,13.3050462 C0.984406154,11.1848677 0.668547692,8.4816 1.59989538,6.08344615 C2.53127077,3.68523692 4.58983385,1.90246154 7.09626462,1.32369231 C9.60264,0.743870769 12.2345723,1.44268338 14.1231877,3.18968308 L14.8684985,2.35891385 C12.6888092,0.360969231 9.65459077,-0.416686154 6.78262154,0.287390769 C3.90954462,0.991606154 1.57951385,3.08486769 0.571236923,5.86489846 C-0.436929231,8.64492923 0.0109107692,11.7439754 1.76330769,14.1260677 C3.51678462,16.5080492 6.34444615,17.8559446 9.29755385,17.7185908 C12.2517692,17.582292 14.9420769,15.9791815 16.4684769,13.4456677 C17.9937138,10.9122646 18.1527231,7.78397538 16.8925015,5.10889846 L16.0615385,6.00673846 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.f0a2986a.svg";
export { ForwardRef as ReactComponent };